import React from 'react';
import IGStoryMentionSlideoutBannerNormalSrc from './IGStoryMentionSlideoutBanner_normal.png';
import IGStoryMentionSlideoutBannerWhiteSrc from './IGStoryMentionSlideoutBanner_white.png';

export const IGStoryMentionSlideoutBanner = ({
  textColor,
}: {
  textColor: 'white' | 'normal';
}) => {
  return textColor === 'white' ? (
    <img src={IGStoryMentionSlideoutBannerWhiteSrc} />
  ) : (
    <img src={IGStoryMentionSlideoutBannerNormalSrc} />
  );
};
